import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

/**
 * Small (i) info tooltip — drop next to any label / button.
 * Usage: <Tip text="Explains this control." />
 */
export default function Tip({ text, side = "top", testId }) {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className="inline-flex align-middle ml-1 h-4 w-4 items-center justify-center text-[#004a99] cursor-help opacity-70 hover:opacity-100"
            data-testid={testId || "info-tip"}
            aria-label="More info"
            tabIndex={0}
          >
            <Info className="h-3.5 w-3.5" />
          </span>
        </TooltipTrigger>
        <TooltipContent side={side} className="max-w-xs text-xs leading-relaxed bg-slate-900 text-white">
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
